// extracted by mini-css-extract-plugin
export default {"borderGrey":"#b5b4b5","zIndexModalBackdrop":"1040","container":"iW8dC2YLK34lzx8B","mainMessage":"kBxlU8gqxXKyOE_V","subMessage":"bGqCuUAW7cYebGzh"};